import { render, staticRenderFns } from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm.vue?vue&type=template&id=f8e72cae"
import script from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports